import type { IApiStore } from '../../../models/ecommerce/store/storeModel';
import type { HybrisPointOfService } from '../models/hybris/hybrisPointOfService';
import type { HybrisCoopStore } from '../models/hybris/hybrisStore';

export const mapPointOfService = (hybrisPickupStore: HybrisPointOfService) => {
    const pickupStore: IApiStore = {
        address: hybrisPickupStore.address
            ? {
                  street: hybrisPickupStore.address.line1,
                  postalCode: hybrisPickupStore.address.postalCode,
                  city: hybrisPickupStore.address.town,
              }
            : undefined,
        deliverySupported: true,
        id: hybrisPickupStore.name,
        name: hybrisPickupStore.displayName,
        pickupSupported: true,
        latitude: hybrisPickupStore.geoPoint?.latitude,
        longitude: hybrisPickupStore.geoPoint?.longitude,
        productionUnitIdentifier: hybrisPickupStore.storeId,
        deliveryModes: hybrisPickupStore.pickupDeliveryModes,
        isPuP: true,
        closestPickupHours: hybrisPickupStore.pickupOpeningHours,
    };

    return pickupStore;
};

export const mapStore = (hybrisStore: HybrisCoopStore) => {
    const store: IApiStore = {
        address: undefined,
        deliverySupported:
            !!hybrisStore.deliveryModes?.length &&
            hybrisStore.deliveryModes.some((dm) => dm.code === 'homedelivery'),
        id: hybrisStore.code,
        name: hybrisStore.name,
        pickupSupported: false,
        productionUnitIdentifier: hybrisStore.code,
    };

    return store;
};
